import PropTypes from 'prop-types';

Scrollbar.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  sx: PropTypes.object,
};

export default function Scrollbar({ children, className = '', sx }) {
  return (
    <div
      className={`overflow-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent hover:scrollbar-thumb-gray-400 ${className}`}
      style={{
        scrollbarWidth: 'thin',
        scrollbarColor: '#D1D5DB transparent',
        height: '100%',
        ...sx,
      }}
    >
      <div className="scrollbar-container" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        {children}
      </div>
    </div>
  );
} 